/* eslint-disable @typescript-eslint/no-explicit-any */
export class DocumentDTO {
  id?: string;
  typeDocument:
    | string
    | ProfileDocumentEnum
    | BillDocumentsEnum
    | TypeDocumentToCandidatureEnum;
  name: string;
  type?: string;
  validated?: boolean;
  file: any;
  taxBase?: string;
  dateYear?: Date | string;
  netAmount?: string;
  date?: Date | string;
  expirationDate?: Date | string;
  birthDate?: Date | string;
  tenantId?: string;
  extension?: string;
  selected?: boolean;
  blob?: any;
  totalAmount?: string;
  model?: string;
  sourceId?: string;
  creationDate?: Date;
  year?: Date | string;
  requestAnalysisId?: string;
  deleted?: boolean;
  url?: string;
  inputStream?: string;
  metadata?: {
    internalReference?: string;
    description?: string;
    type?: TypeDocumentToCandidatureEnum;
  };
}

export class FileDocumentDTO {
  url: string;
}

export class DocumentIncidenceDTO {
  extension: string;
  inputStream: string;
  url: string;
}

export class DocumentValidationDTO {
  document: string;
  optional: boolean;
  minCount: number;
  maxCount: number;
  neededCount: number;
  status: DocumentRequiredSnapshotEnum = DocumentRequiredSnapshotEnum.KO;
}

export class DocumentRequiredSnapshotDTO {
  document: string;
  status: DocumentRequiredSnapshotEnum;
  minCount?: number;
  maxCount?: number;
  neededCount?: number;
  optional: boolean;
}

export enum DocumentRequiredSnapshotEnum {
  OK = 'OK',
  KO = 'KO'
}

export enum TypeDocumentToCandidatureEnum {
  RENT_CONTRACT = 'RENT_CONTRACT',
  SECURITY_DEPOSIT = 'SECURITY_DEPOSIT',
  ACCOUNT_OWNERSHIP = 'ACCOUNT_OWNERSHIP',
  SEPA_MANDATE = 'SEPA_MANDATE',
  ADDITIONAL_GUARANTEES = 'ADDITIONAL_GUARANTEES',
  PAYMENT_RECEIPT = 'PAYMENT_RECEIPT',
  OTHERS = 'OTHERS'
}

export enum ProfileDocumentEnum {
  PROFILE_PHOTO = 'PROFILE_PHOTO'
}

export enum BillDocumentsEnum {
  INSURANCE = 'INSURANCE',
  SUPPLY = 'SUPPLY'
}

export class LastTwoPayslipMonths {
  ultimatePayslip: string;
  penultimatePayslip: string;
}

export class Month {
  value: string;
  text: string;
}
export class Quarter {
  value: string;
  text: string;
}

export interface AttachDocument {
  creationDate: string | Date;
  name: string;
  fileId: string;
}

export interface DocumentRuleAdminResponse {
  id: string;
  buildingId: string | null;
  portfolioId: string | null;
  rules: DocumentRuleAdmin[];
  buildings: string[];
}

export interface DocumentRuleAdmin {
  rol: string;
  foreign: boolean;
  rules: Rule[];
}

export interface Rule {
  document: string;
  optional: boolean;
  minCount: number;
  maxCount: number;
}

export class DocumentTypeDTO {
  id?: string;
  key: string;
  name: string;
  description: string;
}

export class DocumentTypeFormValueDTO extends DocumentTypeDTO {
  nameEn: string;
  nameFr: string;
  nameDe: string;
  descriptionEn: string;
  descriptionFr: string;
  descriptionDe: string;
}

export interface PdfAnalysisResponse {
  filename: string;
  pdfinfo: PdfInfo;
}

export interface PdfInfo {
  [key: string]: any;
}
